import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LOCATION_ADDRESS } from '../config';
import { DEALERSHIP } from '../data/dealership';
import { Reveal } from './Reveal';
export function Faq() {
  const {
    t,
    lang
  } = useLanguage();
  const [open, setOpen] = useState<string | null>(null);

  // Every answer stays conservative — no promise of approval, rates, terms, inventory, or figures.
  const items = [{
    id: 'q1',
    question: t('faq.q1'),
    answer: t('faq.generic')
  }, {
    id: 'q2',
    question: t('faq.q2'),
    answer: t('faq.generic')
  }, {
    id: 'q3',
    question: t('faq.q3'),
    answer: t('faq.generic')
  }, {
    id: 'q4',
    question: t('faq.q4'),
    answer: t('faq.generic')
  }, {
    id: 'q5',
    question: t('faq.q5'),
    answer: t('faq.generic')
  }, {
    id: 'q9',
    question: t('faq.q9'),
    answer: t('faq.a9')
  }, {
    id: 'q10',
    question: t('faq.q10'),
    answer: t('faq.a10')
  }, {
    id: 'q11',
    question: t('faq.q11'),
    answer: t('faq.a11')
  }, {
    id: 'q6',
    question: t('faq.q6'),
    answer: t('faq.a6')
  }, {
    id: 'q7',
    question: t('faq.q7'),
    answer: t('faq.a7')
  }, {
    id: 'q8',
    question: t('faq.q8'),
    // Uses the client-approved dealership address; config.LOCATION_ADDRESS overrides it if set.
    answer: `${t('faq.a8.base')} ${LOCATION_ADDRESS || `${DEALERSHIP.name} · ${DEALERSHIP.address}`}`
  }];
  return <section className="w-full bg-offwhite" data-id="element-21" data-mp="6qez3feh2rsx">
      <div className="mx-auto w-full max-w-3xl px-4 py-16 sm:px-6 md:py-24" data-id="element-22" data-mp="6plqe8vyds85">
        <Reveal data-id="element-23" data-mp="bjhkh093iuy1">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-[0.16em] text-ink sm:text-3xl" data-id="element-24" data-mp="bjzpal9tqhhk">
            {t('faq.title')}
          </h2>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-25" data-mp="1teqoxu5hcyn" />
        </Reveal>

        <dl className="mt-8 border-t border-camel/40" data-id="element-26" data-mp="3jz19fn2qhr7a">
          {items.map((item, index) => {
          const isOpen = open === item.id;
          return <Reveal key={item.id} delay={Math.min(index * 0.03, 0.2)} data-id="element-27" data-mp="1ugun1xgd8dr3" data-mpi={index}>
                <div className="border-b border-camel/40" data-id="element-28" data-mp="1uixm16zhxh7y">
                  <dt data-id="element-29" data-mp="1pp352bb9zgck">
                    <button type="button" onClick={() => setOpen(isOpen ? null : item.id)} aria-expanded={isOpen} aria-controls={`faq-panel-${item.id}`} id={`faq-button-${item.id}`} className="flex min-h-[56px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-30" data-mp="1pojph193l41p">
                      <span className={`text-base font-semibold ${isOpen ? 'text-kred' : 'text-ink'}`} data-id="element-31" data-mp="28eszuyf1g24h">
                        {item.question}
                      </span>
                      {isOpen ? <MinusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-kred" data-id="element-32" data-mp="s2dw1hi5o3h7" /> : <PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-muted" data-id="element-33" data-mp="o094qpf6jixq" />}
                    </button>
                  </dt>
                  <dd id={`faq-panel-${item.id}`} role="region" aria-labelledby={`faq-button-${item.id}`} hidden={!isOpen} className="pb-5 pr-8 text-sm leading-relaxed text-body" data-id="element-34" data-mp="2zmb110l6e4si">
                    {item.answer}
                  </dd>
                </div>
              </Reveal>;
        })}
        </dl>

        {/* Verified manufacturer information — used exactly as provided, with its limitation note. */}
        <Reveal delay={0.1} data-id="element-35" data-mp="3rf20djy5o9lz">
          <aside className="mt-10 border-l-2 border-camel bg-white p-6" data-id="element-36" data-mp="3rftjhvakgevd">
            <h3 className="font-display text-xs font-extrabold uppercase tracking-[0.2em] text-camelink" data-id="element-37" data-mp="7xtqq5xape3">
              {t('warranty.title')}
            </h3>
            <p className="mt-3 text-base leading-relaxed text-body" data-id="element-38" data-mp="220dodjth8toh">{t('warranty.text')}</p>
            <p className="mt-3 text-xs leading-relaxed text-muted" data-id="element-39" data-mp="2226v0z43bdwh">{t('warranty.small')}</p>
            <p className="mt-4 text-xs text-muted" data-id="element-40" data-mp="16s9zs8s4d8vj">
              {DEALERSHIP.name} · {DEALERSHIP.address} · {DEALERSHIP.hours[lang]}
            </p>
          </aside>
        </Reveal>
      </div>
    </section>;
}